module.exports = __webpack_public_path__ + "static/frost-a68222d02c76d3f6e0c615ab613bdda8.png";